// CreateAreascontrolcambiosPage.tsx

import { ROUTER_PATHS,  useTableFilter } from "@/shared";

import { useAprobadoresArea, useFetchDeleteAprobador } from "@/shared/actions";
// import { useFetchUsuariosSistema, useFetchUsuariosSistemaPorArreglo } from "@/shared/actions/erp/administration/usuarios";
import { useMemo, useState } from 'react';
import { useFetchPatchActivo, useFetchPatchPuedeAprobar } from '@/shared/actions';
import { SingleTableBoxScene, GeneralTableColor } from "@/shared/components/ui";
// import { UsuariosSistemaGET } from "@/shared/interfaces";
import { useColumnsUsuarioSistema } from "@/erp/administration/usuarios/shared/hooks";
import { HeaderStyleConfig, StatusColorMap, StatusColumnConfig } from "@/shared/components/ui/GeneralTableColor";
import { Skeleton, Stack } from "@mui/material";
import {
  SwitchComponente,
} from "@/shared/components/ui";
import {  UsuariosSistemaGetExtras } from '@/shared/interfaces';
import { type MRT_ColumnDef } from 'material-react-table';
import { useUiConfirmModalStore } from "@/store/ui";
import { ModalEditarAreaAprobador } from "../../components";
import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";

export default function AprobadoresPage() {
  
  // useCheckPermissions(PermissionsEnum.api_change_areascontrolcambios);

// const { data: datos } = useFetchGetAprobadorArea();

// const ids = datos?.map(item => item.usuarioId) ?? [];
        const user = useAuthStore((s) => s.user) as any; 
        const userModules = useUserModulesStore((s) => s.modules);  
        const isSuper = !!user?.is_superuser || !!user?.is_staff; 
        const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_APROBADORES) 

    const returnURL = ROUTER_PATHS.control_cambios.aprobadorareaanva;
    const { columnsControlCambiosUser  } = useColumnsUsuarioSistema();
    const {
            pagination,
            setPagination,
        } = useTableFilter();
    const { pageIndex, pageSize } = pagination;

    const {
        usuarios,
        total,
        isLoading,
        isRefetching,
        error,
    } = useAprobadoresArea(
        {
            page: pageIndex + 1,
            page_size: pageSize,
        }
    );
    const estadoColorMap: StatusColorMap = {
        'true':    { label: 'Activo',    color: 'success', textColor: 'green' },
        'false':  { label: 'Inactivo',  color: 'error',   textColor: 'red'   },
        Eliminado: { label: 'Eliminado', color: 'default', textColor: 'gray'  },
        };

    const statusColumns: StatusColumnConfig[] = [
    {
        // accessorKey: 'estado',
        accessorKey: 'is_active',
        colorMap: estadoColorMap,
        displayVariant: 'text',   // ← cambia a 'chip' o 'dot' según necesites
    },
    ];
    const headerStyle: HeaderStyleConfig ={
        backgroundColor: '#1e2330',
        textColor: '#ffffff',
        fontWeight: 'bold',
    }
      const isReady =
    !isLoading &&
    !isRefetching;

  if (error) {
    return <div>Error al cargar aprobadores</div>;
  }
  //mutaitons
  const patchActivoMutation = useFetchPatchActivo();
  const patchPuedeAprobarMutation = useFetchPatchPuedeAprobar();
  const deleteAprobador = useFetchDeleteAprobador();
  
 
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );
    const columnasAprobador = useMemo<MRT_ColumnDef<UsuariosSistemaGetExtras>[]>(
    () => [
      {
        accessorKey: 'activo',
        header: 'APROBADOR ACTIVO',
        size: 180,
        // enableColumnFilter: false,
        enableSorting: false,
        accessorFn: (row: any) => (row.activo == null ? "N/A" : row.activo ? "Sí" : "No"),
        filterVariant: "select",
        filterSelectOptions: ["Sí", "No"],
        filterFn: "equals",
        Cell: ({ row }) =>
          row.original?.activo == null ? (
            'N/A'
          ) : (
            <SwitchComponente
              estadoSwitch={row.original.activo}
              titulo={row.original.activo ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar estado',
                  subtitle:
                    '¿Estás seguro que desea cambiar el estado de este aprobador?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    patchActivoMutation.mutate({
                      id: row.original.aprobadorAreaId!,
                      activo: !row.original.activo,
                    });
                  },
                });
              }}
            />
          ),
      },
      {
        accessorKey: 'puedeAprobar',
        header: 'PUEDE APROBAR',
        size: 180,
        enableColumnFilter: false,
        enableSorting: false,
        accessorFn: (row: any) => (row.puedeAprobar == null ? "N/A" : row.puedeAprobar ? "Sí" : "No"),
        filterVariant:"select",
        filterSelectOptions: ["Si", "No"],
        filterFn: "equals",
        Cell: ({ row }) =>
          row.original?.puedeAprobar == null ? (
            'N/A'
          ) : (
            <SwitchComponente
              estadoSwitch={row.original.puedeAprobar}
              titulo={row.original.puedeAprobar ? 'Sí' : 'No'}
              setEstadoSwitch={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar permiso',
                  subtitle:
                    '¿Estás seguro que desea cambiar el permiso de aprobación?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    patchPuedeAprobarMutation.mutate({
                      id: row.original.aprobadorAreaId!,
                      puedeAprobar: !row.original.puedeAprobar,
                    });
                  },
                });
              }}
            />
          ),
      },
      {
        accessorKey: "area",
        header: "ÁREA",
        size: 180,
        // enableColumnFilter: false,
        accessorFn: (row: any) => row.area?.nombre ?? "",
        Cell: ({ row }) => (row.original as any)?.area?.nombre ?? "N/A",
       },
    ],
    [patchActivoMutation, patchPuedeAprobarMutation]
  );
  const columns = useMemo<MRT_ColumnDef<UsuariosSistemaGetExtras>[]>(
    () => [
      ...(columnsControlCambiosUser as MRT_ColumnDef<UsuariosSistemaGetExtras>[]),
      ...columnasAprobador,
    ],
    [columnsControlCambiosUser, columnasAprobador]
  );

  const onDelete = (row: UsuariosSistemaGetExtras) => {
    setConfirmDialog({
            isOpen: true,
            title: "Eliminar aprobador",
            subtitle: `¿Seguro que desea eliminar al aprobador "${row.profile?.razon_social ?? row.username}"? Esta acción no se puede deshacer.`,
            onConfirm: () => {
            setConfirmDialogIsOpen(false);
            deleteAprobador.mutate(row.aprobadorAreaId!);
            },
        });
    };
    const [editRow, setEditRow] = useState<UsuariosSistemaGetExtras | null>(null);
    const onEdit = (row: UsuariosSistemaGetExtras) => setEditRow(row);

    if(!isSuper || !tineAccesoAreacontrolAreas){
   return ( 
    <SingleTableBoxScene
        title="APROBADORES"
        enableRedirect={true}
        urlRedirect={`${returnURL}`}
    >
        {!isReady ? (
             <Stack spacing={1}>
            <Skeleton variant="rectangular" height={50} />
            <Skeleton variant="rectangular" height={50} />
            <Skeleton variant="rectangular" height={50} />
            </Stack>
        ): (

        <GeneralTableColor<UsuariosSistemaGetExtras>
            // columns = {columnsControlCambiosUser}
            columns = {columns}
            
            // data={usuariosSistemaPagingRes?.data.data || []}
            data={usuarios || []}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={total}
            // rowCount={usuariosSistemaPagingRes?.data.count}
            
            darkHeader
            headerStyle={headerStyle}

            statusColumns={statusColumns}
            
            canEdit={true}
            onEdit={onEdit}
            canDelete={true}
            onDelete={onDelete}
        
        />
        )}
        <ModalEditarAreaAprobador open={!!editRow} onClose={() => setEditRow(null)} aprobador={editRow} />    
    </SingleTableBoxScene>
    
   )
    }
     return <Outlet />;
}
